import type { EventGuide } from '../types';
import { chicagoCoordinates, chicagoCenter } from '../../coordinates/chicago';
import { chicagoDays, chicagoBookingChecklist, chicagoQuickReference } from './itinerary';
import { chicagoFuelling } from './fuelling';
import { chicagoShopping } from './shopping';
import { chicagoRaceWeek } from './raceWeek';

export const chicagoGuide: EventGuide = {
  raceId: 'chicago-2026',
  theme: 'chicago',
  accent: '#4a9fcc',
  label: 'Chicago 2026',
  gunLabel: 'Sunday 11 October · Wave 1 07:35 CDT',
  itinerary: {
    heroImage: '/images/chicago-skyline.jpg',
    heroLabel: 'October 7–13, 2026',
    heroTitle: 'Chicago Marathon',
    heroDetails: ['Woodlawn loft · 6156 S St Lawrence Ave', '26.2 Miles Through 29 Neighbourhoods'],
    introTitle: 'Chicago Marathon 2026',
    intro: [
      'Six nights in Chicago from a three-bedroom loft in Woodlawn on the South Side, between Washington Park and the University of Chicago. The kitchen covers the carb load, Jewel-Osco is five minutes away, and the Green Line from Cottage Grove reaches the Loop in about 25 minutes. The marathon is Sunday 11 October: Wave 1 goes at 07:35 on Columbus Drive, then 26.2 flat miles through 29 neighbourhoods, finishing back in Grant Park.',
      'Landing on Wednesday afternoon and flying out at 6 am on Tuesday 13 means the sightseeing is packed in, so each downtown day is one Green Line trip and as much sitting as possible: the Bean, the Art Institute, the river cruise and Quartino on Thursday; the Expo, a sushi lunch and the Bulls on Friday; the Chicago 5K and the lululemon shakeout on race-eve morning, then feet up. After the race: deep dish at Lou Malnati’s South Loop, Medal Monday engraving, AIRE Ancient Baths and the Skydeck.',
      'Expect $6–8 for a specialty coffee, $9–12 for a pint and $40–80 a head for a good dinner. Tip 20%. Take cars for O’Hare, race morning, the United Center and anything after dark; the Green Line covers the rest.',
    ],
    days: chicagoDays,
    coordinates: chicagoCoordinates,
    center: chicagoCenter,
    zoom: 12,
    bookingChecklist: chicagoBookingChecklist,
    quickReference: chicagoQuickReference,
    footerTitle: 'See you in Chicago',
    footerSub: 'October 7–13, 2026',
  },
  fuelling: chicagoFuelling,
  shopping: chicagoShopping,
  raceWeek: chicagoRaceWeek,
};
